import {Component, OnInit, ViewChild} from '@angular/core';
import {actionEmitted, actionSelectEnum, Select2Component} from '@Common/widgets/general/select2';
import {DataTableHeaderCommunicationService} from '@Common/widgets/general/data-table';
import {DepositService} from '../../../services/deposit/deposit.service';
import {Individu} from '@Common/core/services';
import {IndividuService} from '../../../services/helper-individu/individu.service';
import {HeaderFilterService} from '@Common/widgets/general/data-table/services/header-filter.service';
import {FilterDemandeurDepositsData} from './filter-demandeur-depostifs.model';

@Component({
  selector: 'app-filter-demandeur-deposits',
  templateUrl: './filter-demandeur-deposits.component.html',
  styleUrls: ['./filter-demandeur-deposits.component.scss', '../filter-deposits.component.scss']
})
export class FilterDemandeurDepositsComponent extends HeaderFilterService implements OnInit {
  searchIndividu: Individu[] = null;
  @ViewChild('demandeurs', { static: true }) demandeurs: Select2Component<Individu>;
  constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService,
              private depositSvc: DepositService,
              private individuSvc: IndividuService) {
    super(dtCommunicationSvc);
  }

  ngOnInit(): void {
    this.demandeurs.daoService = this.individuSvc;
    this.demandeurs.funSearch = this.individuSvc.searchDemandeurs;
  }
  doAction(value: actionEmitted<Individu>) {
    if (value.action === actionSelectEnum.added) {
      this.searchIndividu = value.itemsList;
    }
    if (value.action === actionSelectEnum.deleted) {
      this.searchIndividu = value.itemsList;
    }
  }
  onValidate(event) {
    const firstIndividu = this.searchIndividu?.shift();
    const name = `${firstIndividu?.first_name} ${firstIndividu?.last_name}`;
    const dataEmit = <FilterDemandeurDepositsData> {
      nameComponent: this.name,
      action: 'validate',
      value: firstIndividu?.uid,
      condition: firstIndividu ? `sur ${name}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }
  onCancel(event) {
  }

  sendAllReinit(reinit: boolean) {
    this._sendReinit();
  }

  sendReinit(filterName: string) {
    this._sendReinit();
  }
  private _sendReinit() {
    this.searchIndividu = null;
    const dataEmit = <FilterDemandeurDepositsData>{nameComponent: this.name, action: 'reinit'};
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
  }
}
